import { Money } from "../common/money";
import { ServiceRequestType } from "./service-request";

export enum SlaStatus {
	OnTrack = 0,
	AtRisk = 1,
	Breached = 2,
	Completed = 3,
}

export enum ExternalServiceRequestStatus {
	Unknown = "Unknown",
	Pending = "Pending",
	Duplicate = "Duplicate",
	Resolved = "Resolved",
	Closed = "Closed",
	Assigned = "Assigned",
	Processing = "Processing",
}

export type ServiceRequestInstanceCustomerData = {
	firstName?: string;
	lastName?: string;
	email?: string;
	phone?: string;
	meterNumber?: string;
	address?: string;
};

export type ServiceRequestInstanceSubmitterData = {
	firstName?: string;
	lastName?: string;
};

export type AssignedUserData = {
	firstName?: string;
	lastName?: string;
};

export type StepInstanceHistoryData = {
	id: string;
	stepName: string;
	createdAt: string;
	updatedAt: string;
	percentageDone: number;
	due: string;
	slaStatus?: SlaStatus;
	departmentId: string;
	departmentName?: string;
	assignedUserId?: string;
	assignedUserName?: AssignedUserData;
};

export type ServiceRequestTransactionResponse = {
	id: string;
	amount: Money;
	reference: string;
	externalReference?: string;
	type: number;
	status: number;
	transactionPaymentType?: number;
	createdAt: string;
	updatedAt: string;
};

export type ServiceRequestInstanceDetailsResponse = {
	id: string;
	ticketNumber: number;
	ticketNumberFormatted: string;
	customerId?: string;
	agentId?: string;
	customerData?: ServiceRequestInstanceCustomerData;
	submitterData?: ServiceRequestInstanceSubmitterData;
	serviceRequestId: string;
	requestTypeId: string;
	requestType?: ServiceRequestType;
	status: number;
	paymentStatus: number;
	price?: Money;
	utilityId: string;
	historyStepsData?: StepInstanceHistoryData[];
	currentStepData?: StepInstanceHistoryData;
	externalId?: string;
	currentExternalStatus?: ExternalServiceRequestStatus;
	transaction?: ServiceRequestTransactionResponse;
	createdAt: string;
	updatedAt: string;
};
